<template>
	<div class="inner-page single-form-submission">

		<AppHead :title="`Form Submission: ${formName}`" />

		<PageHeader 
			:title="`Form Submission: ${formName}`"
			:desc="`You are viewing the results of: ${formName} for case: #${caseName}`"
			:hasButton="false"
			:showHelper="false"
			/>

		<div class="survey-container">
			<div id="survey" />
		</div>

	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"

import "survey-core/defaultV2.min.css";
import { StylesManager } from "survey-core"
import { Survey } from 'survey-knockout-ui'

StylesManager.applyTheme("defaultV2")

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Survey,
		Button
	},
	layout: AppLayout,
	props: {
		formResult: {
			type: [Array, Object, Boolean],
			default: false
		},
		case: {
			type: Object,
			required: true
		},
	},
	data: () => {
		return {
			survey: null
		}
	},
	mounted() {
		console.log('formResult', this.formResult)

		this.survey = new Survey({
			...this.flattenedFormSchema,
			mode: "display",
		})

		this.survey.data = this.formResult.result_data
		this.survey.render("survey")
	},
	computed: {
		flattenedFormSchema(){
			// take this.formResult.form_schema and take the elements from each page and put it in one big array
			let pages = this.formResult.form_schema.pages
			let elements = []
			pages.forEach(page => {
				elements = elements.concat(page.elements)
			})

			return {
				elements: elements
			}
		},
		caseHash() {
			return this.case.hashid
		},
		caseName() {
			return this.case && this.case.enquiry_number ? this.case.enquiry_number : this.case.hashid
		},
		formName(){
			return `${this.formResult.form_name} ${this.formResult.week ? ` (Week ${this.formResult.week})` : ''}`
		}
	}
}

</script>

<style lang="sass">

.single-form-submission
	.survey-container
		.sd-root-modern
			background-color: transparent

		.sd-body.sd-body--static
			padding-top: 0
			padding-bottom: 0

		.sd-row__question, .sd-btn
			border-radius: 8px
			box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2)

		.sd-completedpage 
			h3
				font-family: 'Roboto Condensed', sans-serif
				font-size: 28px
				margin-bottom: 20px

			p
				font-size: 18px
				margin-bottom: 20px

		.sd-root--readonly .sd-input--disabled, .sd-root--readonly .sd-input--disabled::placeholder, .sd-input.sd-input--disabled, .sd-input.sd-input--disabled::placeholder
			opacity: 0.8

		.sd-rating__item.sd-rating__item--selected.sd-rating__item--disabled
			background-color: #333
			fill: #333

			.sd-question--disabled .sd-rating__item-text
				color: #fff
				opacity: .8

</style>